module.exports = __webpack_public_path__ + "assets/img/vip_magnit_slider.1559b47e.png";